import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-wh-teal border-b-4 border-wh-yellow" data-id="element-259">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-260">
        {/* Mascot Image - positioned within container, flush with bottom */}
        <div className="hidden lg:block absolute bottom-0 right-4 sm:right-6 lg:right-8 w-[360px] xl:w-[400px] pointer-events-none z-10" data-id="element-261">
          <img src="https://cdn.magicpatterns.com/uploads/wbAgEfoQRZWHxqkDVncn6B/wearhaus_girl_speech_transparent.png" alt="Wear Haus Mascot" className="w-full h-auto block" style={{
          marginBottom: '-4px'
        }} data-id="element-262" />
        </div>

        <div className="relative min-h-[400px] py-8 lg:py-12 flex items-center" data-id="element-263">
          {/* Content - Full width for H1 */}
          <div className="relative z-20 w-full" data-id="element-264">
            <h1 className="text-4xl lg:text-6xl font-extrabold text-white leading-tight mb-6 lg:pr-[420px] xl:pr-[460px]" data-id="element-265">
              Custom Apparel, Screen Printing & Promotional Products — Serving
              Businesses Nationwide
            </h1>

            <p className="text-lg text-white/95 mb-8 leading-relaxed max-w-2xl" data-id="element-266">
              Specializing in screen printing, embroidery, DTG, DTF, laser
              engraving, and custom promotional products for businesses,
              schools, teams, and events across the United States.
            </p>

            <p className="text-base text-white/95 mb-8 max-w-2xl" data-id="element-267">
              We proudly represent <strong data-id="element-268">contract clients</strong> and provide
              scalable production for established brands nationwide.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-269">
              <Link to="/contact" data-id="element-270">
                <Button variant="primary" size="lg" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-272" />} className="!bg-wh-pink !text-white hover:!bg-pink-600 !border-0" data-id="element-271">
                  Get a Quote
                </Button>
              </Link>
              <Link to="/services" data-id="element-273">
                <Button variant="primary" size="lg" className="!bg-wh-yellow !text-gray-900 hover:!bg-yellow-400 !border-0" data-id="element-274">
                  View Our Services
                </Button>
              </Link>
            </div>

            <div className="mt-12 flex flex-wrap items-center gap-6 text-sm font-semibold text-white/90" data-id="element-275">
              <div className="flex items-center gap-2" data-id="element-276">
                <div className="w-2 h-2 rounded-full bg-white" data-id="element-277" />
                In-House Production
              </div>
              <div className="flex items-center gap-2" data-id="element-278">
                <div className="w-2 h-2 rounded-full bg-wh-yellow" data-id="element-279" />
                Fast Turnaround
              </div>
              <div className="flex items-center gap-2" data-id="element-280">
                <div className="w-2 h-2 rounded-full bg-wh-pink" data-id="element-281" />
                30+ Years in Business
              </div>
            </div>
          </div>

          {/* Mobile Mascot Image - Scaled down */}
          <div className="lg:hidden absolute bottom-0 right-0 w-48 sm:w-64 opacity-30 pointer-events-none" data-id="element-282">
            <img src="https://cdn.magicpatterns.com/uploads/wbAgEfoQRZWHxqkDVncn6B/wearhaus_girl_speech_transparent.png" alt="Wear Haus Mascot" className="w-full h-auto block" style={{
            marginBottom: '-4px'
          }} data-id="element-283" />
          </div>
        </div>
      </div>
    </section>;
}